export const env = {
  builderApiKey: process.env.NEXT_PUBLIC_BUILDER_API_KEY ?? "",
  builderGraphqlEndpoint:
    process.env.NEXT_PUBLIC_BUILDER_GRAPHQL_ENDPOINT ?? "",
  magentoGraphqlEndpoint:
    process.env.NEXT_PUBLIC_MAGENTO_GRAPHQL_ENDPOINT ?? "",
  brand: process.env.NEXT_PUBLIC_BRAND ?? "",
  devDebugFetchCache: process.env.NEXT_PUBLIC_DEV_DEBUG_FETCH_CACHE ?? "",
  fetchCacheEnable: process.env.NEXT_PUBLIC_FETCH_CACHE_ENABLE ?? "",
  siteUrl: process.env.NEXT_PUBLIC_SITE_URL ?? "",
  magentoRootCategoryUid: process.env.NEXT_PUBLIC_ROOT_CATEGORY_UID ?? "",
  availableMagentoStores:
    process.env.NEXT_PUBLIC_AVAILABLE_MAGENTO_STORES ?? "",
} as const;
